export const apiConfig = {
  AGGREGATED_FREE_CASHFLOW_REQUEST_URL: '/api/eval_calculator/eval_start',
  AGGREGATED_FREE_CASHFLOW_RESULT_URL: '/api/eval_calculator/eval_result',
  AGGREGATED_FREE_CASHFLOW_CASHFLOWS_BY_MONTH_URL:
    '/api/eval_calculator/eval_result/cashflows_by_month',
  AGGREGATED_FREE_CASHFLOW_EXPORT_URL:
    '/api/eval_calculator/eval_result/export_cashflows',
  AFE_CATALOG_EXPORT_URL: '/afe_headers/export',
  ROYALTY_CHECKS_EXPORT_URL: '/royalty_checks/export',
};
